var translateWidget = function googleTranslateElementInit() {
  new google.translate.TranslateElement({pageLanguage: 'ja', includedLanguages: 'en,ko,zh-CN,zh-TW', autoDisplay: false}, 'google_translate_element');
}

// bodyにモバイルメニューで必要なタグを挿入する
$('body').append(
  '<div class="translation__area" style="display: none;">' +
    '<i class="icon icon-close translation__close"></i>' +
    '<h3>言語を選択してください。</h3>' +
    '<div class="translation__bubble-area">' +
      '<div id="google_translate_element"></div>' +
    '</div>' +
    '<svg class="translation__cat" role="img" width="200" height="150">' +
      '<title>みたいにゃ マスコット</title>' +
      '<use xlink:href="#mitainya"></use>' +
    '</svg>' +
  '</div>'
);

// 新規<script>タグを作成し、カスタムコードを設定する
$(".translation__area")
  .append($("<script />", {
    html: "function googleTranslateElementInit() {new google.translate.TranslateElement({pageLanguage: 'ja', includedLanguages: 'en,ko,zh-CN,zh-TW', autoDisplay: false}, 'google_translate_element'); }"
  })
);

// 新規<script>タグを作成し、Google Translateのスクリプトをsrcに設定する
$("body").append($("<script />", {
  src: "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
}));

$(function() {
  setInterval(function() {
    var text = $('.goog-te-combo option:selected').text();
    if (text == '日本語' || text == '言語を選択') {
      $("#lang_ja").show();
      $(".toc__item--ja").show();

      $("#lang_en").hide();
      $("#lang_kr").hide();
      $("#lang_ch").hide();
      $("#lang_tw").hide();
      $(".toc__item--en").hide();
      $(".toc__item--kr").hide();
      $(".toc__item--ch").hide();
      $(".toc__item--tw").hide();
    } else if (text == '英語') {
      $("#lang_ja").hide();
      $(".toc__item--ja").hide();

      $("#lang_en").show();
      $(".toc__item--en").show();

      $("#lang_kr").hide();
      $("#lang_ch").hide();
      $("#lang_tw").hide();
      $(".toc__item--kr").hide();
      $(".toc__item--ch").hide();
      $(".toc__item--tw").hide();
      $("body").addClass("lang-en");
    } else if (text == '韓国語') {
      $("#lang_ja").hide();
      $("#lang_en").hide();
      $(".toc__item--ja").hide();
      $(".toc__item--en").hide();

      $("#lang_kr").show();
      $(".toc__item--kr").show();

      $("#lang_ch").hide();
      $("#lang_tw").hide();
      $(".toc__item--ch").hide();
      $(".toc__item--tw").hide();
      $("body").addClass("lang-kr");
    } else if (text == '中国語(簡体)') {
      $("#lang_ja").hide();
      $("#lang_en").hide();
      $("#lang_kr").hide();
      $(".toc__item--ja").hide();
      $(".toc__item--en").hide();
      $(".toc__item--kr").hide();

      $("#lang_ch").show();
      $(".toc__item--ch").show();

      $("#lang_tw").hide();
      $(".toc__item--tw").hide();
      $("body").addClass("lang-ch");
    } else if (text == '中国語(繁体)') {
      $("#lang_ja").hide();
      $("#lang_en").hide();
      $("#lang_kr").hide();
      $("#lang_ch").hide();
      $(".toc__item--ja").hide();
      $(".toc__item--en").hide();
      $(".toc__item--kr").hide();
      $(".toc__item--ch").hide();

      $("#lang_tw").show();
      $(".toc__item--tw").show();
      $("body").addClass("lang-tw");
    } else {
      $("#lang_ja").show();
      $(".toc__item--ja").show();

      $("#lang_en").hide();
      $("#lang_kr").hide();
      $("#lang_ch").hide();
      $("#lang_tw").hide();
      $(".toc__item--en").hide();
      $(".toc__item--kr").hide();
      $(".toc__item--ch").hide();
      $(".toc__item--tw").hide();
      $("body").addClass("lang-ja");
    }
  });
});